import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { useTranslation } from "react-i18next";

const  EdTopTracksTable = ({ topTracksData }) => {
  const { t } = useTranslation();

  const tableOptions = {
    noDataText: t("general.table.noDataAvailable"),
  };

  return (
    <>
      <BootstrapTable
        hover
        condensed
        search={false}
        bordered={false}
        data={topTracksData}
        deleteRow={false}
        insertRow={false}
        tableHeaderClass="mb-0"
        options={tableOptions}
      >
        <TableHeaderColumn width="100" dataField="track_name" isKey={true} dataSort={true}>
          {t("earningsDrilldown.view.top5Tracks.table.column.trackName")}
        </TableHeaderColumn>
        
        <TableHeaderColumn width="100" dataField="track_revenue" dataSort={true}>
          {t("earningsDrilldown.view.top5Tracks.table.column.revenue")}
        </TableHeaderColumn>
      </BootstrapTable>
    </>
  );
};

export default EdTopTracksTable;
